import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import ChartHeader from '@/modules/Statistics/components/ChartHeader.vue';
import VueApexCharts from 'vue-apexcharts';
import { DashboardReportFields } from '@/modules/Statistics/interfaces/DashboardReport';

interface Props {
    data: DashboardReportFields;
    isEdit: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PieChart',
  props: {
    data: null,
    isEdit: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    data: DashboardReportFields;
    isEdit: boolean;
};

const chart = VueApexCharts;



const chartWidth = ref('100%');
const series = ref<null | number[]>(null);
const options = ref<any>(null);

const chartHeight = computed(() => {
    switch (props.data.size) {
        case 'L':
            return '150%';
        case 'M':
            return '120%';
        default:
            return '80%';
    }
});

const chartFontSize = computed(() => {
    switch (props.data.size) {
        case 'L':
            return '15px';
        case 'M':
            return '13px';
        default:
            return '10px';
    }
});

const chartSize = computed(() => {
    switch (props.data.size) {
        case 'S':
            return {
                width: '48%',
                height: '48%',
            };
        default:
            return {
                width: '100%',
                height: '100%',
            };
    }
});

function changeChartSize(size: 'S' | 'M' | 'L') {
    props.data.size = size;
}

function updateChart(data: any) {
    options.value = {
        chart: {
            type: 'pie',
            toolbar: {
                show: false,
            },
            events: {
                mounted: (chartInstance: any) => {
                    chartInstance.windowResizeHandler();
                },
            },
        },
        labels: data.statisticReport.data.values.map((item: any) => item[0]),
        dataLabels: {
            enabled: props.data.size === 'S' ? false : true,
            formatter: (val: any, opts: any) => {
                return opts.w.globals.series[opts.seriesIndex];
            },
            style: {
                fontSize: chartFontSize.value,
            },
        },
        tooltip: {
            y: {
                // Format percentage for the tooltip;
                formatter: (value: any, opts: any) => {
                    const sum = opts.globals.series.reduce((a: number, b: number) => a + b, 0);
                    const current = opts.globals.series[opts.seriesIndex];
                    const percentage = (current / sum) * 100;
                    return value + ` (${percentage.toFixed(0)}%)`;
                },
            },
        },
        legend: {
            // Format legend data
            formatter: (seriesName: any, opts: any) => {
                return [
                    `<span class="legend-title">${seriesName}<span/>`,
                    `<span class="legend-amount">${opts.w.globals.series[opts.seriesIndex]}<span/>`,
                    ,
                ];
            },
            itemMargin: {
                vertical: 5,
            },

            position: 'right',
            fontSize: chartFontSize.value,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 150,
                    },
                    legend: {
                        position: 'center',
                    },
                },
            },
        ],
    };

    series.value = data.statisticReport.data.values.map((item: any) => item[1]);
}

watch(
    () => props.data,
    (newVal: any) => {
        if (newVal.statisticReport.data.values.length) {
            updateChart(newVal);
        }
    },
    { deep: true, immediate: true },
);

return { __sfc: true,chart, props, chartWidth, series, options, chartHeight, chartFontSize, chartSize, changeChartSize, updateChart, ChartHeader }
}

})